export default{
  props:{
    property:Object,
    options:{
      type:Object,
      default:()=>{return{}}
    },
    value:[String,Number,Boolean,Object,Array]
  },
  computed:{
    label(){
      const p = this.property;
      return p.unit?p.title+", "+p.unit.title:p.title;
    },
    placeholder(){
      return this.options.placeholder||this.label;
    },
    getValue(){
      const p = this.property;
      return p.unit?(this.value!=null ? this.value : this.oldValue)*p.unit.coeffForUI :
        (this.value!=null ? this.value : this.oldValue);//кода значение не проходит валидацию, то в value=undefined, поэтому оставляем для пользователя его последние введенное значение, а не удаляем его
    },
  },
  data () {
    return {
      errors:[],
      oldValue:null
    };
  },
  methods:{
    convertValueToModel(property, value){
      if (!value)return value;

      if (property.type=='integer'&&(property.format=="date-time"||property.format=="date")) return new Date(value).getTime();
      if (property.type=='integer'||property.type=='number') {
        return property.unit?(+value)/property.unit.coeffForUI:+value;
      }
      if (property.type=='boolean') return !!value;

      return value;
    },

    setValue(newValue){

      if (newValue!=undefined)this.oldValue=newValue;

      const convertedValue = this.convertValueToModel(this.property,newValue);

      if (this.property.type!='object'){
        this.errors=this.$ajv.validate(this.property, convertedValue)?[]:this.$ajv.errors.map(i=>i.message)
        //console.log(this.errors)
      }

      this.$emit('input',convertedValue);

    }
  }
}
